import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
} from 'nuqs'
import { JET_CALL_REPORT_STATUS_VALUES } from 'pages/Jet/shared/constants/status'

export const useJetStatusFiltersQueryState = () => {
  return useQueryStates(
    {
      statuses: parseAsArrayOf(
        parseAsStringLiteral(JET_CALL_REPORT_STATUS_VALUES)
      ),
      search: parseAsString.withDefault(''),
      daysAgo: parseAsInteger.withDefault(30),
    },
    {
      urlKeys: {
        statuses: 'statuses',
        search: 'search',
        daysAgo: 'days-ago',
      },
    }
  )
}
